export const PHYSICAL_CARD_CLAIM_CODE_LENGTH = 8;
export const PHYSICAL_CARD_CLAIM_PREFIX = "H-";
export const PHYSICAL_CARD_CLAIM_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

const CLAIM_CODE_PATTERN = new RegExp(
  `^[${PHYSICAL_CARD_CLAIM_ALPHABET}]{${PHYSICAL_CARD_CLAIM_CODE_LENGTH}}$`,
);

export function sanitizePhysicalAssetIdInput(value = "") {
  return String(value || "")
    .trim()
    .toUpperCase()
    .replace(/[\u2010\u2011\u2012\u2013\u2014\u2015\u2212-]/g, "-")
    .replace(/\s+/g, "");
}

export function normalizePhysicalAssetIdInput(value = "", hasHPrefix = false) {
  const sanitized = sanitizePhysicalAssetIdInput(value);
  let prefix = "";
  let body = sanitized;

  if (body.startsWith(PHYSICAL_CARD_CLAIM_PREFIX)) {
    prefix = PHYSICAL_CARD_CLAIM_PREFIX;
    body = body.slice(PHYSICAL_CARD_CLAIM_PREFIX.length);
  } else if (
    body.length === PHYSICAL_CARD_CLAIM_CODE_LENGTH + 1 &&
    body.startsWith("H")
  ) {
    prefix = PHYSICAL_CARD_CLAIM_PREFIX;
    body = body.slice(1);
  } else if (hasHPrefix) {
    prefix = PHYSICAL_CARD_CLAIM_PREFIX;
  }

  body = body.replace(/-/g, "");

  return {
    assetId: `${prefix}${body}`,
    body,
    hasHPrefix: prefix === PHYSICAL_CARD_CLAIM_PREFIX,
    isValid: CLAIM_CODE_PATTERN.test(body),
  };
}

export function getPhysicalAssetIdValidationError(value = "", hasHPrefix = false) {
  const parsed = normalizePhysicalAssetIdInput(value, hasHPrefix);

  if (!parsed.body) {
    return "Enter the asset ID printed on your physical card.";
  }

  if (parsed.body.length !== PHYSICAL_CARD_CLAIM_CODE_LENGTH) {
    return `Asset IDs must be ${PHYSICAL_CARD_CLAIM_CODE_LENGTH} characters.`;
  }

  if (!parsed.isValid) {
    return "Use only letters A-Z without I or O, and numbers 2-9.";
  }

  return "";
}
